module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.curInput.input,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [(_vm.curInput.input.write_type != 90) ? _c('el-form-item', {
    attrs: {
      "label": "是否唯一"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.input.is_unique),
      expression: "curInput.input.is_unique"
    }],
    domProps: {
      "value": (_vm.curInput.input.is_unique)
    },
    on: {
      "input": function($event) {
        _vm.curInput.input.is_unique = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("否")])])]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "填写类型",
      "prop": "write_type"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.input.write_type),
      expression: "curInput.input.write_type"
    }],
    staticClass: "h-40 w-200",
    attrs: {
      "placeholder": "请选择填写类型"
    },
    domProps: {
      "value": (_vm.curInput.input.write_type)
    },
    on: {
      "input": function($event) {
        _vm.curInput.input.write_type = $event
      }
    }
  }, _vm._l((_vm.writeType), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))]), _vm._v(" "), (_vm.curInput.input.write_type != 90) ? _c('el-form-item', {
    attrs: {
      "label": "默认值",
      "prop": "default"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.curInput.input.write_default),
      expression: "curInput.input.write_default",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-200",
    domProps: {
      "value": (_vm.curInput.input.write_default)
    },
    on: {
      "input": function($event) {
        _vm.curInput.input.write_default = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.curInput.input.write_type == 90) ? _c('el-form-item', {
    attrs: {
      "label": "公式",
      "prop": "formula"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.curInput.input.formula),
      expression: "curInput.input.formula",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-200",
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": (_vm.curInput.input.formula)
    },
    on: {
      "input": function($event) {
        _vm.curInput.input.formula = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.editFormula
    }
  }, [_vm._v("公式编辑")])]) : _vm._e()]), _vm._v(" "), (_vm.curInput.input.write_type == _vm.TYPE_NUMBER) ? _c('textlen-config', {
    attrs: {
      "rules": _vm.rules,
      "config": _vm.curInput.input,
      "maxCount": 11,
      "limitMax": true
    }
  }) : (_vm.curInput.input.write_type == _vm.TYPE_IDCARD) ? _c('textlen-config', {
    attrs: {
      "rules": _vm.rules,
      "config": _vm.curInput.input,
      "maxCount": 18,
      "limitMax": true,
      "disabled": true
    }
  }) : (_vm.curInput.input.write_type == _vm.TYPE_FLOATNUMBER) ? _c('textlen-config', {
    attrs: {
      "rules": _vm.rules,
      "config": _vm.curInput.input,
      "maxCount": 20,
      "limitMax": true,
      "disabled": _vm.disabled,
      "isdecimal": _vm.isdecimal
    }
  }) : (_vm.curInput.input.write_type == _vm.TYPE_BANK) ? _c('textlen-config', {
    attrs: {
      "rules": _vm.rules,
      "config": _vm.curInput.input,
      "maxCount": 30,
      "limitMax": true,
      "disabled": _vm.disabled
    }
  }) : _c('textlen-config', {
    attrs: {
      "rules": _vm.rules,
      "config": _vm.curInput.input,
      "maxCount": 256,
      "limitMax": true
    }
  }), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), (_vm.isNumber) ? [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.curInput.input,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "最小值限制",
      "prop": "default"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.input.min_limit),
      expression: "curInput.input.min_limit"
    }],
    staticClass: "h-40 w-200",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.curInput.input.min_limit)
    },
    on: {
      "input": function($event) {
        _vm.curInput.input.min_limit = _vm._n($event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "最大值限制",
      "prop": "default"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.input.max_limit),
      expression: "curInput.input.max_limit"
    }],
    staticClass: "h-40 w-200",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.curInput.input.max_limit)
    },
    on: {
      "input": function($event) {
        _vm.curInput.input.max_limit = _vm._n($event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])] : _vm._e(), _vm._v(" "), _vm._v(" "), _c('el-dialog', {
    ref: "dialog",
    attrs: {
      "title": "编辑公式表达(fx)",
      "modal": false,
      "close-on-click-modal": false
    }
  }, [_c('div', {
    staticClass: "form-tips fz-14 m-b-10"
  }, [_vm._v("使用说明：可以用各种控件计算出这个控件的值，目前支持四则运算，字段名用英文半角双引号导入，+-*/四则运算符号，并支持括号()。特别的，若要对外键进行运算，需加上对应关联的表的字段名，如：需外键a所关联表的字段b，则写a.b。")]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.explain),
      expression: "explain"
    }],
    attrs: {
      "type": "textarea",
      "rows": 8,
      "placeholder": "请输入内容"
    },
    domProps: {
      "value": (_vm.explain)
    },
    on: {
      "input": function($event) {
        _vm.explain = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "m-b-10 m-t-10"
  }, [_vm._v("公式")]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formulaData),
      expression: "formulaData"
    }],
    attrs: {
      "type": "textarea",
      "rows": 8,
      "placeholder": "请输入内容"
    },
    domProps: {
      "value": (_vm.formulaData)
    },
    on: {
      "input": function($event) {
        _vm.formulaData = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-tips fz-14"
  }, [_vm._v("示例：(\"input_1\" + \"num\")*(\"money\" * 0.15)")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer m-b-10",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("保存")])])])], true)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-96434926!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Model/configComponents/textConfig.vue
// module id = 1959
// module chunks = 2